var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_847_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5734 3.05655C19.8976 0.776279 15.9181 1.18644 13.462 3.72062L12.5001 4.71183L11.5382 3.72062C9.08702 1.18644 5.10265 0.776279 2.42687 3.05655C-0.639538 5.67374 -0.800671 10.371 1.94347 13.2079L11.3917 22.9638C12.0021 23.5937 12.9933 23.5937 13.6036 22.9638L23.0519 13.2079C25.8009 10.371 25.6398 5.67374 22.5734 3.05655Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_847_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLike);
export default __webpack_public_path__ + "static/media/active-like.82c35d33124ce47011e43325775d6d12.svg";
export { ForwardRef as ReactComponent };